<div>
    <h3 class="title d-none d-lg-block" translate="Settings.AccountWorkgroupsSection.Workgroups">
        <app-info-button labelName="Settings.AccountWorkgroupsSection.WorkgroupsTooltip" [url]="WorkgroupsUrl">

        </app-info-button>
    </h3>
    <h3 class="px-3 pt-4 pb-2 d-block d-lg-none" translate="Settings.AccountWorkgroupsSection.Workgroups">
        <app-info-button labelName="Settings.AccountWorkgroupsSection.WorkgroupsTooltip" [url]="WorkgroupsUrl">

        </app-info-button>
    </h3>
</div>

<div class="p-4 pt-0 px-3 pb-4 p-lg-4 pt-lg-0">
    <app-user-workgroups [userGuid]="currentUserGuid"></app-user-workgroups>
</div>